import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";
import api from "../../utils/api";

import { useHubSnackBar } from "../useSnackBar";

const STATIONDISPLAY = "/stationdisplays";

const getAllStationDisplays = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${STATIONDISPLAY}?${queryString}`);
};
export const useGetAllStationDisplays = (locationId) => {
  return useQuery([STATIONDISPLAY, { locationId }], getAllStationDisplays, {
    enabled: !!locationId,
    staleTime: 6_000_000,
    keepPreviousData: true,
  });
};

const getStationDisplay = ({ queryKey }) => {
  const [_, id] = queryKey;
  return api.get(`${STATIONDISPLAY}/${id}`);
};
export const useGetStationDisplay = (id) => {
  return useQuery([STATIONDISPLAY, id, "/display"], getStationDisplay, {
    enabled: !!id,
    retry: false,
    staleTime: 600_000,
    cacheTime: 1_800_000,
    keepPreviousData: true,
    refetchOnWindowFocus: true,
  });
};

const getStationDisplayData = (id) => api.get(`${STATIONDISPLAY}/data/${id}`);
export const useGetStationDisplayData = (id) => {
  return useQuery(
    [STATIONDISPLAY, "data", id],
    () => getStationDisplayData(id),
    {
      enabled: !!id,
      staleTime: 600_000,
      cacheTime: 1_800_000,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
    },
  );
};

const postCreateStationDisplay = (payload) => api.post(STATIONDISPLAY, payload);
export const usePostCreateStationDisplay = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(postCreateStationDisplay, {
    onSuccess: () => {
      queryClient.invalidateQueries(STATIONDISPLAY);
      addSnackbarSuccess({ message: "Successfully Created Station Display" });
    },
  });
};

const putStationDisplayData = (data) => {
  const id = data.id;
  delete data.id;
  return api.put(`${STATIONDISPLAY}/${id}`, data);
};
export const usePutStationDisplayData = (id) => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putStationDisplayData, {
    onSuccess: () => {
      queryClient.invalidateQueries([STATIONDISPLAY, id]);
      addSnackbarSuccess({ message: "Successfully Updated Display" });
    },
  });
};

const putStationDisplaySortOrder = ({ displays }) =>
  api.put(`${STATIONDISPLAY}/sortOrder`, { displays });
export const usePutStationDisplaySortOrder = () => {
  const queryClient = useQueryClient();

  return useMutation(putStationDisplaySortOrder, {
    onSuccess: () => {
      queryClient.invalidateQueries(STATIONDISPLAY);
    },
  });
};

const putStationDisplayLayout = (data) => {
  const id = data.id;
  delete data.id;
  return api.put(`${STATIONDISPLAY}/layout/${id}`, data);
};
export const usePutStationDisplayLayout = (id) => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(putStationDisplayLayout, {
    onSuccess: () => {
      queryClient.invalidateQueries([STATIONDISPLAY, id]);
      addSnackbarSuccess({ message: "Successfully Updated Display" });
    },
  });
};

const deleteStationDisplay = (id) => api.delete(`${STATIONDISPLAY}/${id}`);
export const useDeleteStationDisplay = () => {
  const { addSnackbarSuccess } = useHubSnackBar();
  const queryClient = useQueryClient();

  return useMutation(deleteStationDisplay, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === STATIONDISPLAY,
      });
      addSnackbarSuccess({ message: "Successfully Deleted Display" });
    },
  });
};
